import { axios } from './index'

const resource = '/v1/stay'
const resource_logout = '/v1/stay/logout';

export default {
  /**
   * 初回ログイン完了
   */
  putComplete(params) {
    return axios.put(`${resource}/complete_first_login`, params)
  },

  checkLoginRakuten() {
    return axios.get(`${resource}/rakuten/check-login-rakuten`)
  },

  /**
   * ログアウト
   */
  getLogout() {
    return axios.get(`${resource_logout}`);
  }
}
